import { environment } from '../../environments/environment';

export class StudisuConfig {
  public suchworteServicePath = '/pc/v1/suchwoerter';
  public studienangeboteServiceHost: string;
  public studienfaecherServicePath = '/pc/v1/studienfaecher';
  public studienfaecherServicePathAc = '/pc/v1/studienfaecher_ac';
  public studienfelderServicePath = '/pc/v1/studienfelder';
  public studienfelderServicePathAc = '/pc/v1/studienfelder_ac';
  public studienfelderByStudienfachServicePath = '/pc/v1/studienfelder/bystudienfach';
  public studienfeldBeschreibung = '/pc/v1/studienfeldbeschreibung';
  public studienfeldInformationen = '/pc/v1/studienfeldinformationen';
  public studienangebotInformationen = '/pc/v1/studienangebotinformationen';
  public bildungsanbieterSignet = '/ct/v1/signet';
  public studienangeboteServicePath = '/pc/v1/studienangebote';
  public studienangeboteIdsServicePath = '/pc/v1/studienangebote_ids';
  public studienangeboteCountServicePath = '/pc/v1/studienangebote_count';
  public facettenServicePath = '/pc/v1/facetten';
  public ortServicePath = '/pc/v1/orte';
  public versionInfoPath = '/pc/v1/versionsinformationen';
  public feedbackScriptUrl;
  public geoisStylesheetUrl;
  public geoisScriptUrl;
  public geoisImageServer;
  public geoisGeocodeServer;
  public berufeTvTemplateUrl;
  public berufepoolHost;

  constructor(data) {
    Object.assign(this, data);
  }

  public keys(): Array<string> {
    return Object.keys(this);
  }
}

export function _getStudisuConfig(studisuConfig: any): StudisuConfig {
  let config = new StudisuConfig({});

  if (studisuConfig === null && typeof studisuConfig !== 'object') {
    return new StudisuConfig(config);
  }
  for (let i in studisuConfig) {
    if (!studisuConfig.hasOwnProperty(i)) {
      continue;
    }

    let entry = studisuConfig[i];
    if (!/^{{.*}}$/.test(entry)) {
      config[i] = entry;
      // handy for debugging, pls dont delete me :)
      // console.log("config[" + i + "] = " + entry);
    }
  }

  return new StudisuConfig(config);
}

export function getStudisuConfig(): StudisuConfig {
  return _getStudisuConfig(environment.config || null);
}
